import { countryToCurrency } from '../dropdownOptions';
import { DEFAULT_PRICING_MODEL } from '../pages/constants';
import { CountryCode, Customer, Option, TangoTeamProduct } from '../pages/types';

export const isCanadianCustomer = (customer: Customer) => {
  return customer.default_country === CountryCode.CA;
};

/**
 * Pricing models are currency specific, so only the ones priced in the selected
 * country's currency are meaningful for that country.
 */
export const getPricingModelOptionsForCountry = (
  products: TangoTeamProduct[] | undefined,
  country: string
): Option[] => {
  const currency = countryToCurrency[country];
  const isDefaultByName = new Map<string, boolean>();

  for (const product of products ?? []) {
    for (const price of Object.values(product.prices ?? {})) {
      if (price?.pricing_model_name && price.currency === currency) {
        const name = String(price.pricing_model_name);
        isDefaultByName.set(name, isDefaultByName.get(name) || Boolean(price.is_default));
      }
    }
  }

  return Array.from(isDefaultByName, ([name, isDefault]) => ({
    label: name,
    value: name,
    isDefault,
  }));
};

export const getDefaultPricingModelOption = (pricingModelOptions: Option[]): Option =>
  pricingModelOptions.find((option) => option.isDefault) ??
  pricingModelOptions.find((option) => option.value === DEFAULT_PRICING_MODEL) ??
  pricingModelOptions[0] ?? { label: DEFAULT_PRICING_MODEL, value: DEFAULT_PRICING_MODEL };
